
import _ from 'lodash';
window._ = _;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import $ from 'jquery';
window.$ = window.jQuery = $;

// bootstrap-sass requires window.jQuery at load time, so use dynamic import
// (static imports are hoisted above assignments, breaking the jQuery check)
import('bootstrap-sass');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Cancel in-flight axios requests when the page is being hidden (before unload
 * or bfcache store). Pending requests are a common reason Chrome rejects
 * pages for the back/forward cache, causing slow reloads on back navigation.
 *
 * Each request gets a signal from a shared AbortController. On pagehide,
 * we abort and replace the controller for future requests.
 */
let pageAbortController = new AbortController();
window.axios.interceptors.request.use((config) => {
    // Only attach our signal if the caller didn't provide one of their own
    if (!config.signal) {
        config.signal = pageAbortController.signal;
    }
    return config;
});
window.addEventListener('pagehide', () => {
    pageAbortController.abort();
    pageAbortController = new AbortController();
});

/**
 * Demo mode — public anonymous demo of the AML panel.
 *
 * When the demo blade view sets window.__DEMO_MODE__ before this script
 * runs, install the axios adapter that intercepts every backend call.
 * No requests reach the server in demo mode — handlers return canned
 * fixtures and sessionStorage tracks user mutations until reload.
 * See resources/js/demo/.
 *
 * IMPORTANT — adapter is installed SYNCHRONOUSLY here, not via dynamic
 * import. The AML panel fires axios calls (subscription, notifications,
 * dashboard) the moment Vue mounts; if the adapter were async-loaded,
 * those first calls would race past the safety net and hit the real
 * server. Static import + sync install closes that gap.
 *
 * Handler modules (which carry the bulk of the demo's bytes) are still
 * loaded asynchronously below — they don't need to be ready before the
 * adapter is installed because the adapter's safety net will block any
 * unmocked call until handlers register.
 *
 * The interceptor module is small (~3KB) and a no-op when not in demo
 * mode, so the bundle-size cost for non-demo users is trivial.
 */
import { installDemoInterceptor, markHandlersReady } from './demo/interceptor.js';
import { installDownloadGuard } from './demo/downloadGuard.js';

if (window.__DEMO_MODE__) {
    installDemoInterceptor();
    // Install the download guard synchronously, immediately after the
    // axios adapter. Every export/download in the panel uses
    // window.open() or anchor clicks — both bypass axios. Without this
    // guard those calls hit the real backend over the visitor's
    // existing session and serve someone else's real data. See
    // resources/js/demo/downloadGuard.js for the full URL pattern set.
    installDownloadGuard();
    import('./demo/install.js')
        .then((m) => m.install())
        .catch((err) => {
            // Gate-release safety: if the install path fails (broken
            // import, syntax error, network blip on a cold hard
            // refresh) we still have to flip the readiness flag so
            // queued requests don't hang forever waiting for handlers
            // that will never register. They'll fall through to the
            // safety net, which is the right failure mode — the demo
            // shows "feature not available" toasts rather than a
            // permanent loading state behind the agreements gate.
            console.error('[demo] Failed to load demo handlers:', err);
            markHandlersReady();
        });
}
